import { Modal, Button } from 'react-bootstrap';

export const ConfirmationScreenModeChange = ({ currentMode, modeToChange, setConfirmationScreenModeChange, onShow, onClose }) => {

    const handleClose = () => {
        if (onClose) {
            onClose();
        }
    };

    const handleAction = (confirmation) => {
        setConfirmationScreenModeChange(confirmation);
        handleClose();
    };

    if (onShow) {
        document.body.classList.add('modal-open');
    } else {
        document.body.classList.remove('modal-open');
    }

    const isSameMode = currentMode === modeToChange;

    return (
        <div>
            <Modal
                className="clear-background"
                show={onShow}
                tabIndex="-1"
                onHide={handleClose}
                backdrop="static"
                backdropClassName="custom-backdrop-class"
                style={{ top: '150px' }}
            >
                <Modal.Header closeButton>
                    <Modal.Title></Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='mt-2 mb-5'>
                        <strong>
                            {isSameMode
                                ? `Are you sure you want to turn the ${modeToChange} mode off?`
                                : `Are you sure you want to change the screen mode to ${modeToChange}?`}
                        </strong>
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center align-items-center flex-column">
                    <Button
                        variant="primary"
                        onClick={() => handleAction(true)}
                    >
                        <strong>CHANGE MODE</strong>
                    </Button>
                    <Button
                        variant="link"
                        className="text-danger"
                        onClick={() => handleAction(false)}
                    >
                        Cancel the operation
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}